var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('VueEditor',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)},"text-change":function($event){return _vm.$emit('change')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }